<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-sys__accessmanagement}">
        <div class="du">
            <div></div>
        </div>
        <!-- <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:accessmanagement:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:accessmanagement:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
          </el-form-item>
        </el-form> -->
        <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle($event,true)"  style="width: 100%;">
         
          <el-table-column prop="city" label="城市" sortable="custom" header-align="center" align="center"></el-table-column>
          <el-table-column prop="products" label="产品" sortable="custom" header-align="center" align="center"></el-table-column>
          <el-table-column prop="needClueNum" label="锁定线索数量" sortable="custom" header-align="center" align="center"></el-table-column>
          <el-table-column prop="assignedClueNum" label="实际线索数量" sortable="custom" header-align="center" align="center"></el-table-column>
          <el-table-column prop="assignedClueRatio" label="完成比例"  sortable="custom" header-align="center" align="center">
            <template slot-scope="scope">
                <div class="progress" >
                    <div  :style="{
                        width:(scope.row.assignedClueRatio > 100 ? '100' : scope.row.assignedClueRatio )+ '%',
                        color: (scope.row.assignedClueRatio) ?  '#fff' : '#606266' ,
                        background: (scope.row.assignedClueRatio)  >= 100 ? 'red' : (scope.row.assignedClueRatio) >= 90 ? 'blue' : (scope.row.assignedClueRatio-0) >= 80 ? 'yellow' : 'green',
                    }">
                        {{ scope.row.assignedClueRatio}}
                    </div>
                </div>
            </template>
          </el-table-column>
         
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
            getDataListURL: '/sys/kanban/page',
        getDataListIsPage: true,
        exportURL: '/sys/kanban/export',
        deleteURL: '/sys/kanban',
        deleteIsBatch: true
      },
     
        dataForm: {
          id: ''
        }
      }
    },
    methods: {
        setStyle(v){
            // console.log(this.$refs.progressChild)
            console.log(v)
            return v;
        }
    }
   
  }
  </script>
  <style lang="scss" scoped>
  .progress{
    height: 40px;
    width: 100%;
    overflow: hidden;
    >div{
    line-height: 40px;
  
  }
   
  }
  
  ::v-deep .cell{
    padding: 0;
    
  }
  </style>